import React from "react";
import settings from "@src/settings";
import styled, { css } from "styled-components";
import { Props } from "./";
import trimLeading from "@src/utils/trimLeading";
import ArticleImageColumn from "../ArticleImageColumn";
import getGridHeight from "@src/utils/getGridHeight";
import { down } from "styled-breakpoints";

const fontSize = settings.voiceGrid.fontSize;
const lineGap = settings.voiceGrid.lineGap;
export const Frame = styled.dl<{
	type: Props["type"];
	as?: keyof JSX.IntrinsicElements;
}>`
	display: flex;
	color: ${settings.color.main};
	padding-left: 3rem;
	& > dt {
		flex: 0 0 3rem;
		margin-left: -3rem;
		font-family: ${(props) =>
			["speaker", "host", "continued"].includes(props.type)
				? settings.font.jp
				: settings.font.en};
		font-weight: ${(props) =>
			["speaker", "host", "continued"].includes(props.type) ? 700 : 800};
		font-size: ${(props) =>
			["speaker", "host", "continued"].includes(props.type) ? "16px" : "25px"};
		line-height: ${fontSize}px;
		text-align: center;
		${(props) => ["host", "continued"].includes(props.type) && "color: #FFF;"}
	}
	& > dd {
		font-family: ${settings.font.jp};
		font-weight: ${(props) =>
			["Q", "host"].includes(props.type) ? "bold" : "normal"};
		letter-spacing: 2.2857px;
		white-space: pre-line;
		${trimLeading({ fontSize: fontSize, lineHeight: fontSize + lineGap })}
		text-align: justify;
	}
	& + &,
	${ArticleImageColumn} + & {
		margin-top: ${fontSize + lineGap + (lineGap - fontSize) / 2}px;
	}
	${down("xs")} {
		display: block;
		padding-left: 0;
		& > dt {
			${(props) =>
				["host", "continued"].includes(props.type)
					? css`
							display: none;
					  `
					: css`
							margin-left: 0;
							text-align: left;
							margin-bottom: ${lineGap}px;
					  `}
		}
	}
`;

export const Lead = styled.p`
	font-family: ${settings.font.jp};
	font-weight: bold;
	letter-spacing: 2.2857px;
	white-space: pre-line;
	${trimLeading({
		fontSize: fontSize * (8 / 7),
		lineHeight: fontSize + lineGap,
	})}
	color: ${settings.color.main};
	margin-bottom: ${getGridHeight({
		rows: 2,
		withBottomGap: true,
		fontSize: fontSize,
		lineGap: lineGap,
	})}px;
	& + &,
	${ArticleImageColumn} + & {
		margin-top: ${fontSize + lineGap + (lineGap - fontSize) / 2}px;
	}
	${down("xs")} {
		margin-bottom: 42px;
	}
`;
